import type { WorkOrderAssignmentCandidate, WorkOrderAssignmentRow } from "../../../contract"

export const recommendedWorkOrderCandidates = (
  row: WorkOrderAssignmentRow,
): WorkOrderAssignmentCandidate[] => (row.propertyId ? row.preferredCandidates : row.candidates)
